import { render } from "./PasswordExpiresHeader.vue?vue&type=template&id=1459653c"
import script from "./PasswordExpiresHeader.vue?vue&type=script&lang=js"
export * from "./PasswordExpiresHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__